import { AgendaItem, NestedAgendaItem } from "..";

export const agendaItemHelper =
{
    getLastChild,
    getSortedAgendaItems
}

function getLastChild(parentId:string, agendaItems:AgendaItem[]):AgendaItem | undefined
{

    let lastChild = parentId===''
        ? agendaItems.find(ai => ai.relationType === 'root' && ai.relationId === '')
        : agendaItems.find(ai => ai.relationType === 'parent' && ai.relationId === parentId);
    let nextChild = lastChild;

    while(nextChild){
        lastChild = nextChild;
        nextChild = agendaItems.find(ai => ai.relationType === 'previous' && ai.relationId===lastChild?.id);
    }
    
    return lastChild;
}

function getSortedAgendaItems(items:AgendaItem[])
{
    return getSortedChildren(items, '', 0);
}

function getSortedChildren(agendaItems:AgendaItem[], parentId:string, depth:number):NestedAgendaItem[]
{

    let nextChild = parentId===''
        ? agendaItems.find(ai => ai.relationType === 'root' && ai.relationId === '')
        : agendaItems.find(ai => ai.relationType === 'parent' && ai.relationId === parentId);

    const children:NestedAgendaItem[] = [];
    // If no first child is found, loop is skipped
    let index = 0;
    let previousId = '';
    while(nextChild){
        // push current
        children.push({...nextChild, parentId, previousId, depth, index:index++ });
        // push children
        children.push(...getSortedChildren(agendaItems, nextChild.id, depth+1));
        previousId = nextChild.id;
        // get next sibling
        nextChild = agendaItems.find(ai => ai.relationType === 'previous' && ai.relationId===nextChild?.id);
    }
    
    return children;
}